<div
  [ngSwitch]="icon.iconClass"
  *ngIf="(!icon.property || data[icon.property] === true) && !icon.img"
  class="ins-table-cell-icon-container"
>
  <img
    *ngSwitchCase="'insight-icon-type-DeviceAndroidForWork'"
    src="{{ 'online-mobile-device.svg' | xsImage : '/sotixsight/get-resource/assets/images/' }}"
  />
  <img
    *ngSwitchCase="'insight-icon-type-DeviceAndroidGeneric'"
    src="{{ 'online-mobile-device.svg' | xsImage : '/sotixsight/get-resource/assets/images/' }}"
  />
  <img
    *ngSwitchCase="'insight-icon-type-DeviceWindowsDesktop'"
    src="{{ 'online-windows-device.svg' | xsImage : '/sotixsight/get-resource/assets/images/' }}"
  />
  <svg-icon-deviceId
    *ngSwitchCase="'insight-icon-device'"
    class="ins-table-cell-icon"
    [ngStyle]="{ color: icon.iconColor }"
    [matTooltip]="icon.tooltip"
  ></svg-icon-deviceId>
  <i
    *ngSwitchCase="'insight-icon-smartbattery'"
    class="ins-table-cell-icon default-icon-color {{ icon.iconClass }}"
    [class.active-battery]="data.rowContext.devices > 0"
    [matTooltip]="icon.tooltip"
  ></i>
  <i
    *ngSwitchDefault
    class="ins-table-cell-icon {{ icon.iconClass }}"
    [ngStyle]="{ color: icon.iconColor }"
    [matTooltip]="icon.tooltip"
    [soti-tooltip]="icon.sotiTooltip"
    placement="top"
    delay="500"
  ></i>
</div>
<div *ngIf="icon.img" class="ins-table-cell-icon-container">
  <img
    class="ins-table-cell-icon"
    [matTooltip]="icon.tooltip"
    [soti-tooltip]="icon.sotiTooltip"
    placement="top"
    delay="500"
    [src]="icon.img"
    alt=""
  />
</div>
